import { Routes, Route } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Test from './Test';
import ENFP from './ENFP';
import ISTJ from './ISTJ';
import INTJ from './INTJ';
import INTP from './INTP';
import ISTP from './ISTP';
import ISFP from './ISFP';
import INFJ from './INFJ';
import INFP from './INFP';
import ISFJ from './ISFJ';
import ENFJ from './ENFJ';
import ENTJ from './ENTJ';
import ENTP from './ENTP';
import ESFJ from './ESFJ';
import ESFP from './ESFP';
import ESTJ from './ESTJ';
import ESTP from './ESTP';
import './Result.css';

function Result()
{
    const location = useLocation();
  const { IE, NS, TF, PJ } = location.state || {};
     if (IE == 'I' && NS == 'N' && TF == 'T' && PJ == 'J')
  {
    return(
    <INTJ/>
      );
  }
  if (IE == 'I' && NS == 'N' && TF == 'T' && PJ == 'P')
  {
     return(
   <INTP/>
       );
  }
    if (IE == 'E' && NS == 'N' && TF == 'T' && PJ == 'J')
  {
     return(
     <ENTJ/>
       );
  }
   if (IE == 'E' && NS == 'N' && TF == 'T' && PJ == 'P')
  {
     return(
     <ENTP/>
       );
  }
   if (IE == 'I' && NS == 'N' && TF == 'F' && PJ == 'J')
  {
     return(
     <INFJ/>
       );
  }
   if (IE == 'I' && NS == 'N' && TF == 'F' && PJ == 'P')
  {
     return(
     <INFP/>
       );
  }
  if (IE == 'E' && NS == 'N' && TF == 'F' && PJ == 'J')
  {
     return(
     <ENFJ/>
       );
  }
  if (IE == 'E' && NS == 'N' && TF == 'F' && PJ == 'P')
  {
     return(
     <ENFP/>
       );
  }
   if (IE == 'I' && NS == 'S' && TF == 'T' && PJ == 'J')
  {
     return(
     <ISTJ/>
       );
  }
   if (IE == 'E' && NS == 'S' && TF == 'T' && PJ == 'J')
  {
     return(
     <ESTJ/>
       );
  }
   if (IE == 'I' && NS == 'S' && TF == 'F' && PJ == 'J')
  {
     return(
     <ISFJ/>
       );
  }
   if (IE == 'E' && NS == 'S' && TF == 'F' && PJ == 'J')
  {
     return(
     <ESFJ/>
       );
  }
  if (IE == 'I' && NS == 'S' && TF == 'T' && PJ == 'P')
  {
     return(
     <ISTP/>
       );
  }
  if (IE == 'E' && NS == 'S' && TF == 'T' && PJ == 'P')
  {
     return(
     <ESTP/>
       );
  }
  if (IE == 'I' && NS == 'S' && TF == 'F' && PJ == 'P')
  {
     return(
     <ISFP/>
       );
  }
  if (IE == 'E' && NS == 'S' && TF == 'F' && PJ == 'P')
  {
     return(
     <ESFP/>
    );
  }
  
}
export default Result;